/** @format */

import { createAsyncThunk } from "@reduxjs/toolkit";

const MANUAL_ORDER_API_ENDPOINT = `${process.env.REACT_APP_DEV_URL}/merchant/order`;

export const CreateManualOrder = createAsyncThunk(`CreateManualOrder`, async (data, { rejectWithValue }) => {
   try {
      const response = await fetch(`${MANUAL_ORDER_API_ENDPOINT}/`, {
         method: "POST",
         headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("savedT")}`,
            "ngrok-skip-browser-warning": "true",
         },
         body: JSON.stringify(data),
      });

      if (response.status == 201 || response.status == 200) {
         const resData = await response.json();
         console.log("Created manual order response ", resData);
         return resData;
      } else {
         return rejectWithValue("Can't create the Offer");
      }
   } catch (error) {
      throw error;
   }
});

export const UpdateManualOrder = createAsyncThunk(`UpdateManualOrder`, async (data, { rejectWithValue }) => {
   try {
      const response = await fetch(`${MANUAL_ORDER_API_ENDPOINT}/${data.order_id}`, {
         method: "PUT",
         headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("savedT")}`,
            "ngrok-skip-browser-warning": "true",
         },
         body: JSON.stringify(data),
      });

      if (response.status == 201 || response.status == 200) {
         const resData = await response.json();
         console.log("Created manual order response ", resData);
         return resData;
      } else {
         return rejectWithValue("Can't create the Offer");
      }
   } catch (error) {
      throw error;
   }
});
